import { Injectable } from '@angular/core';
import { HttpRequestService } from '../_common/http-request.service';

@Injectable()
export class TwitterService {

    RequestOptions: any = {};

    constructor(
        private http: HttpRequestService,
    ) { }

    gets(parameters) {
        return this.http.get('twitters', parameters)
            .map(res => {
                return res.json();
            })
    }

    stop(model: any) {
        return this.http.put(`twitters/stop`,
            model).map(res => {
                return res.json();
            });
    }

    delete(id: number) {
        return this.http.delete(`twitters/delete?id=${id}`)
            .map(res => {
                return res.json();
            });
    }

    add(model: any) {
        return this.http.post('twitters/add', model)
            .map(res => {
                return res.json();
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/twitter.service.ts